import { toast } from "sonner";
import { Mail } from "lucide-react";
import { api, fmtErr } from "@/lib/api";
import { selectCls } from "./ListingsTab";

export const RequestsTab = ({ requests, reload }) => {
  const setStatus = async (r, status) => {
    try { await api.patch(`/admin/requests/${r.id}`, { status }); toast.success(`Request ${status}`); reload(); } catch (e) { toast.error(fmtErr(e)); }
  };
  if (!requests.length) return <p className="py-16 text-center text-[#cbbbe6]" data-testid="admin-requests-empty">No item requests yet.</p>;
  return (
    <ul className="divide-y divide-[#281245] border-y border-[#281245]" data-testid="admin-requests">
      {requests.map((r) => (
        <li key={r.id} className="grid gap-4 py-6 md:grid-cols-12" data-testid={`admin-request-${r.id}`}>
          <div className="md:col-span-5">
            <p className="font-display text-2xl text-[#f3eefc]">{r.item}</p>
            <p className="font-mono-j mt-1 text-xs text-[#a78bce]">{[r.brand, r.size, r.budget].filter(Boolean).join(" · ") || "No extra details"}</p>
            {r.notes && <p className="mt-2 text-sm italic text-[#cbbbe6]">“{r.notes}”</p>}
          </div>
          <div className="text-sm text-[#cbbbe6] md:col-span-4">
            <p className="text-[#f3eefc]">{r.name}</p>
            <p>{r.email}</p>
            <p className="font-mono-j mt-1 text-xs text-[#a78bce]">{new Date(r.created_at).toLocaleDateString("en-CA")}</p>
          </div>
          <div className="flex gap-2 md:col-span-3">
            <select value={r.status} onChange={(e) => setStatus(r, e.target.value)} className={`${selectCls} flex-1`} data-testid={`admin-request-status-${r.id}`}>
              {["New", "Sourcing", "Found", "Closed"].map((s) => <option key={s}>{s}</option>)}
            </select>
            <a href={`mailto:${r.email}?subject=${encodeURIComponent(`Your request: ${r.item}`)}`} className="grid place-items-center rounded-sm border border-[#3b1d63] px-3 text-[#d8b4fe] hover:border-[#a855f7]" data-testid={`admin-request-email-${r.id}`} aria-label="Email requester"><Mail className="h-4 w-4" /></a>
          </div>
        </li>
      ))}
    </ul>
  );
};
